import { useEffect, useState } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Spinner from 'react-bootstrap/esm/Spinner';
import {
  activateOrganizerUser,
  createOrganizerUser,
  getOrganizerUsers,
  inactivateOrganizerUser,
  updateOrganizerUser,
} from '../../api/User';
import AddButton from '../../components/Buttons/AddButton';
import CustomToast from '../../components/CustomToast';
import EmptyState from '../../components/EmptyState';
import Loading from '../../components/Loading';
import ModalCentered from '../../components/ModalCentered';
import PageTitle from '../../components/PageTitle';
import AddOrganizerUserModal from './AddOrganizerUserModal';
import EditOrganizerUserModal from './EditOrganizerUserModal';
import OrganizerUsersCard from './OrganizerUsersCard';
import OrganizerUsersTable from './OrganizerUsersTable';

function OrganizerAdmins() {
  const [organizerUserList, setOrganizerUserList] = useState();
  const [newOrganizerUserModalShow, setNewOrganizerUserModalShow] =
    useState(false);
  const [editOrganizerUserModalShow, setEditOrganizerUserModalShow] =
    useState(false);
  const [
    inactivateOrganizerUserModalShow,
    setInactivateOrganizerUserModalShow,
  ] = useState(false);
  const [activateOrganizerUserModalShow, setActivateOrganizerUserModalShow] =
    useState(false);
  const [chosenOrganizerUser, setChosenOrganizerUser] = useState();
  const [updating, setUpdating] = useState(false);
  const [loading, setLoading] = useState(true);
  const [toastType, setToastType] = useState('');
  const [toastTitle, setToastTitle] = useState('');
  const [toastBody, setToastBody] = useState('');
  const [showToast, setShowToast] = useState(false);

  useEffect(() => {
    async function fetchOrganizerUsers() {
      const result = await getOrganizerUsers();
      if (result) {
        setOrganizerUserList(result.list);
        setLoading(false);
      }
    }
    fetchOrganizerUsers();
  }, [
    newOrganizerUserModalShow,
    activateOrganizerUserModalShow,
    inactivateOrganizerUserModalShow,
    editOrganizerUserModalShow,
  ]);

  const onAddOrganizerUser = async (values) => {
    setUpdating(true);
    const result = await createOrganizerUser(values);
    if (result) {
      switch (result?.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Användare skapad');
          setToastBody('Användarprofil har lagts till på arrangörskontot');
          break;
        default:
          setToastType('danger');
          setToastTitle('Användare ej skapad');
          setToastBody(result.message);
          break;
      }
      setNewOrganizerUserModalShow(false);
      setUpdating(false);
      setShowToast(true);
    }
  };

  const onEditOrganizerUser = async (values) => {
    setUpdating(true);
    const result = await updateOrganizerUser(chosenOrganizerUser.id, values);
    if (result) {
      switch (result.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Användare uppdaterad');
          setToastBody('Användarens uppgifter har uppdaterats');
          break;
        default:
          setToastType('danger');
          setToastTitle('Användare ej redigerad');
          setToastBody('Kunde inte redigera användare');
          break;
      }
      setEditOrganizerUserModalShow(false);
      setUpdating(false);
      setShowToast(true);
      setChosenOrganizerUser('');
    }
  };

  const onInactivateOrganizerUser = async () => {
    setUpdating(true);
    const result = await inactivateOrganizerUser(chosenOrganizerUser.id);
    if (result) {
      switch (result.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Användare inaktiverad');
          setToastBody('Användaren har blivit inaktiverad');
          break;
        default:
          setToastType('danger');
          setToastTitle('Användare ej inaktiverad');
          setToastBody('Användaren kunde inte inaktiveras');
          break;
      }
      setInactivateOrganizerUserModalShow(false);
      setUpdating(false);
      setShowToast(true);
      setChosenOrganizerUser('');
    }
  };

  const onActivateOrganizerUser = async () => {
    setUpdating(true);
    const result = await activateOrganizerUser(chosenOrganizerUser.id);
    if (result) {
      switch (result.statusCode) {
        case 200:
          setToastType('success');
          setToastTitle('Användare aktiverad');
          setToastBody('Användaren har blivit aktiverad');
          break;
        default:
          setToastType('danger');
          setToastTitle('Användare ej aktiverad');
          setToastBody('Användaren kunde inte aktiveras');
          break;
      }
      setActivateOrganizerUserModalShow(false);
      setUpdating(false);
      setShowToast(true);
      setChosenOrganizerUser('');
    }
  };

  const addOrganizerUserBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Skapa
        </>
      ) : (
        'Skapa'
      )}
    </>
  );

  const editOrganizerUserBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Spara
        </>
      ) : (
        'Spara'
      )}
    </>
  );

  const inactivateBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Inaktivera
        </>
      ) : (
        'Inaktivera'
      )}
    </>
  );

  const activateBtn = (
    <>
      {updating ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
          Aktivera
        </>
      ) : (
        'Aktivera'
      )}
    </>
  );

  return (
    <div>
      <Row>
        <PageTitle
          title='Användare'
          includeLinkBack={true}
          linkBackUrl='/organizer/competitions'
        />
      </Row>
      <Row>
        <Col md={9} lg={8} xl={7} xxl={6}>
          <p className='mt-3 text-secondary'>
            Lägg till användarkonton. Användare kan skapa och administrera
            tävlingar, men har inte behörighet att redigera klubbuppgifter eller
            lägga till användare.
          </p>
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col
          sm={5}
          md={4}
          lg={3}
          xl={3}
          xxl={2}
          className='d-flex justify-content-between'
        >
          <AddButton
            text='Ny användare'
            onClick={() => setNewOrganizerUserModalShow(true)}
            className='w-100'
          />
        </Col>
      </Row>
      <Row>
        {loading ? (
          <div className='d-flex justify-content-center align-items-center mt-5'>
            <Loading size='100px' text='Laddar användare' />
          </div>
        ) : organizerUserList && organizerUserList.length > 0 ? (
          <>
            <Col className='d-none d-lg-flex mt-2'>
              <OrganizerUsersTable
                userList={organizerUserList}
                chosenOrganizerUser={setChosenOrganizerUser}
                onInactivate={() => setInactivateOrganizerUserModalShow(true)}
                onActivate={() => setActivateOrganizerUserModalShow(true)}
                onEdit={() => setEditOrganizerUserModalShow(true)}
              />
            </Col>
            <Col className='d-flex flex-column gap-3 d-lg-none mt-4'>
              {organizerUserList?.map((a, index) => {
                return (
                  <OrganizerUsersCard
                    key={index}
                    user={a}
                    chosenOrganizerUser={setChosenOrganizerUser}
                    onInactivate={() =>
                      setInactivateOrganizerUserModalShow(true)
                    }
                    onActivate={() => setActivateOrganizerUserModalShow(true)}
                    onEdit={() => setEditOrganizerUserModalShow(true)}
                  />
                );
              })}
            </Col>
          </>
        ) : (
          <EmptyState
            headingText='Inga användare tillagda'
            bodyText='Lägg till ny användare som kan skapa och administrera tävlingar'
            action={
              <AddButton
                text='Ny användare'
                onClick={() => setNewOrganizerUserModalShow(true)}
              />
            }
          />
        )}
      </Row>
      <AddOrganizerUserModal
        addOrganizerUser={onAddOrganizerUser}
        confirmBtnText={addOrganizerUserBtn}
        show={newOrganizerUserModalShow}
        onHide={() => setNewOrganizerUserModalShow(false)}
      />
      <EditOrganizerUserModal
        editOrganizerUser={onEditOrganizerUser}
        organizerUser={chosenOrganizerUser}
        confirmBtnText={editOrganizerUserBtn}
        show={editOrganizerUserModalShow}
        onHide={() => setEditOrganizerUserModalShow(false)}
      />
      <ModalCentered
        header='Inaktivera användare'
        body={<span>Är du säker på att du vill inaktivera användaren?</span>}
        confirmBtnText={inactivateBtn}
        onConfirm={() => {
          onInactivateOrganizerUser();
          setInactivateOrganizerUserModalShow(false);
        }}
        show={inactivateOrganizerUserModalShow}
        onHide={() => setInactivateOrganizerUserModalShow(false)}
      />
      <ModalCentered
        header='Aktivera användare'
        body={<span>Är du säker på att du vill aktivera användaren?</span>}
        confirmBtnText={activateBtn}
        onConfirm={() => {
          onActivateOrganizerUser();
          setActivateOrganizerUserModalShow(false);
        }}
        show={activateOrganizerUserModalShow}
        onHide={() => setActivateOrganizerUserModalShow(false)}
      />
      <CustomToast
        type={toastType}
        title={toastTitle}
        body={toastBody}
        show={showToast}
        onClose={() => setShowToast(false)}
      />
    </div>
  );
}

export default OrganizerAdmins;
